import type {
  ApplyLinkRuleBulkRequest,
  ApplyLinkRuleBulkResponse,
  CreateLinkRuleRequest,
  LinkRule,
  UpdateLinkRuleRequest,
} from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

const base = (spaceId: string, itemTypeId: string) =>
  `/api/spaces/${spaceId}/item-types/${itemTypeId}/link-rules`;

export type ListLinkRulesDirection = 'outgoing' | 'incoming' | 'any';

export async function listLinkRules(
  spaceId: string,
  itemTypeId: string,
  options: { direction?: ListLinkRulesDirection } = {},
): Promise<LinkRule[]> {
  const url =
    options.direction && options.direction !== 'outgoing'
      ? `${base(spaceId, itemTypeId)}?direction=${options.direction}`
      : base(spaceId, itemTypeId);
  return apiRequest<LinkRule[]>(url, { method: 'GET' });
}

export async function createLinkRule(
  spaceId: string,
  itemTypeId: string,
  data: CreateLinkRuleRequest,
): Promise<LinkRule> {
  return apiRequest<LinkRule>(base(spaceId, itemTypeId), {
    method: 'POST',
    body: data,
  });
}

export async function updateLinkRule(
  spaceId: string,
  itemTypeId: string,
  ruleId: string,
  data: UpdateLinkRuleRequest,
): Promise<LinkRule> {
  return apiRequest<LinkRule>(`${base(spaceId, itemTypeId)}/${ruleId}`, {
    method: 'PATCH',
    body: data,
  });
}

export async function deleteLinkRule(
  spaceId: string,
  itemTypeId: string,
  ruleId: string,
): Promise<void> {
  await apiRequest<void>(`${base(spaceId, itemTypeId)}/${ruleId}`, {
    method: 'DELETE',
  });
}

export async function applyLinkRuleBulk(
  spaceId: string,
  itemTypeId: string,
  ruleId: string,
  body: ApplyLinkRuleBulkRequest,
): Promise<ApplyLinkRuleBulkResponse> {
  return apiRequest<ApplyLinkRuleBulkResponse>(
    `${base(spaceId, itemTypeId)}/${ruleId}/apply-bulk`,
    {
      method: 'POST',
      body,
    },
  );
}
